/**
 * Created by PanJiaChen on 16/11/18.
 */

import { getCookies } from "@/utils/utils";

import api_teach from "@/fetch/url_teach";
import api_study from "@/fetch/url_study";
import api_train from "@/fetch/url_train";
import api_self from "@/fetch/url_self";
import api_processAssess from "@/fetch/url_processAssess";

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  // if (diff < 30) {
  //   return '刚刚'
  // } else if (diff < 3600) {
  //   // less 1 hour
  //   return Math.ceil(diff / 60) + '分钟前'
  // } else if (diff < 3600 * 24) {
  //   return Math.ceil(diff / 3600) + '小时前'
  // } else if (diff < 3600 * 24 * 2) {
  //   return '1天前'
  // }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getFullYear() +'年'+
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function getServiceTime(e,connat){
  let _timeYear = '';
  let _time = "";
  _timeYear = e.start_time.substr(0,10);
  _time = `${e.start_time.substr(11)} ${connat} ${e.end_time.substr(11)}`;
  return `${_timeYear} (${_time})`;
}
// 获取id数组
export function getIds(list,key) {
  let arr = []
  if(list && list.length){
    list.forEach(item => {
      arr.push(item[key]);
    })
  } 
  return arr;
}
// 清洗请求参数
export function cleanParams(data) {
  let _obj = {};
  if (data) {
    Object.keys(data).forEach((key) => {
      if (data[key] === 0 || data[key]) {
        _obj[key] = data[key];
      }
    });
  } else {
    _obj = "";
  }

  return _obj;
}

export const getApi = () => {
  let _api = api_teach.url;
  // let _api = api_study.url;
  let _frameType = getCookies("frameType") || "";
  if (_frameType) {
    if (_frameType === "study") {
      _api = api_study.url;
    } else if (_frameType === "teach") {
      _api = api_teach.url;
    } else if (_frameType === "train") {
      _api = api_train.url;
    } else if (_frameType === "selfExam") {
             _api = api_self.url;
           } else if (_frameType === "processAssess") {
                    _api = api_processAssess.url;
                  }
  }
  return _api;
};


// WEBPACK FOOTER //
// ./src/utils/index.js